import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PageAlert from '../PageAlert';

import styles from './index.module.scss';

const ValidationErrors = ({ errors = {} }) => {
  const onErrorClick = (e, fieldId) => {
    e.preventDefault();
    // Focus corresponding input.
    const inputElement = document.querySelector(`.field-${fieldId.replaceAll('.', '\\.')} input`);
    if (inputElement) {
      const style = window.getComputedStyle(inputElement);

      // We have RadioFields for the IE Bank account (SEPA). Radio fields have hidden input,
      // therefore we need to focus Label instead of input.
      if (style.display !== 'none') {
        inputElement.focus();
      } else {
        const labelElement = document.querySelector(
          `.field-${fieldId.replaceAll('.', '\\.')} .radios-values label`,
        );
        if (labelElement) {
          labelElement.focus();
        }
      }
    }
  };

  const firstLinkRef = useRef(null);

  useEffect(() => {
    if (firstLinkRef && firstLinkRef.current) {
      firstLinkRef.current.focus();
    }
  }, []);

  const getErrorMessage = (result, obj, prefix) => {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'object') {
        getErrorMessage(result, obj[key], `${prefix ? `${prefix}.${key}` : key}`);
      } else if (typeof obj[key] === 'string') {
        result[`${prefix ? `${prefix}.${key}` : key}`] = obj[key];
      }
    });
    return result;
  };

  const errorMessages = getErrorMessage({}, errors);

  const orderOfFieldsOnDonationForm = [
    'amount',
    'school_number',
    'first_name',
    'last_name',
    'email',
    'phone',
    'address.country',
    'address.addressLine1',
    'address.locality',
    'address.postalCode',
    'source_code',
    'payment_options.card_number_status',
    'payment_options.name',
    'payment_options.card_expiry_status',
    'payment_options.card_cvv_status',
    'payment_options.account_name',
    'payment_options.sort_code.0',
    'payment_options.sort_code.1',
    'payment_options.sort_code.2',
    'payment_options.account_number',
    'payment_options.swift',
    'payment_options.iban',
    'payment_options.accept_direct_debits',
    'payment_options.one_signatory',
  ];

  const errorKeys = Object.keys(errorMessages).sort(
    (a, b) => orderOfFieldsOnDonationForm.indexOf(a) - orderOfFieldsOnDonationForm.indexOf(b),
  );

  const countErrors = errorKeys.length;
  const validationErrorMessage = `There ${
    countErrors === 1 ? 'is 1 error' : `are ${countErrors} errors`
  } in this form`;

  return (
    <PageAlert
      className={`validation-alert ${styles['validation-alert']}`}
      showCloseButton={false}
      role="alert"
      data-component="donation-form-validation-error-message"
      aria-labelledby="validation-error-title"
    >
      <h3 id="validation-error-title">{validationErrorMessage}</h3>
      <ul>
        {errorKeys.map((errorKey, index) => (
          <li key={errorKey} className={styles['focus-button']}>
            <a
              href="#"
              ref={index === 0 ? firstLinkRef : null}
              onClick={(e) => onErrorClick(e, errorKey)}
              onKeyPress={(e) => onErrorClick(e, errorKey)}
              tabIndex="0"
            >
              {errorMessages[errorKey]}
            </a>
          </li>
        ))}
      </ul>
    </PageAlert>
  );
};

ValidationErrors.propTypes = {
  errors: PropTypes.shape({}),
};

export default ValidationErrors;
